import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.object.keys.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import classNames from 'classnames';
import { Impression, ImpressionContext } from '@nerdwallet/analytics/react/impression';
import { defaultProps } from './api';
import { TableContainer } from './TableContainer';
import { BaseTable } from './BaseTable';
import styles from './Table.module.less'; // eslint-disable-next-line react/prop-types

export var Table = function Table(_ref) {
  var analytics = _ref.analytics,
      className = _ref.className,
      rowHover = _ref.rowHover,
      props = _objectWithoutProperties(_ref, ["analytics", "className", "rowHover"]);

  return (
    /*#__PURE__*/
    // eslint-disable-next-line react/prop-types
    React.createElement(Impression, {
      entityName: "table_scroll_h",
      enabled: analytics === null || analytics === void 0 ? void 0 : analytics.enabled
    }, /*#__PURE__*/React.createElement(ImpressionContext.Consumer, null, function (impressionContext) {
      return /*#__PURE__*/React.createElement(TableContainer, {
        analytics: analytics,
        impressionId: impressionContext === null || impressionContext === void 0 ? void 0 : impressionContext.impressionId
      }, /*#__PURE__*/React.createElement(BaseTable, _extends({}, props, {
        className: classNames(className, _defineProperty({}, styles.rowHover, rowHover))
      })));
    }))
  );
};

if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line global-require, react/forbid-foreign-prop-types
  var _require = require('./api'),
      propTypes = _require.propTypes;

  Table.propTypes = propTypes;
}

Table.defaultProps = defaultProps;